export const PERMISSIONS = {
  dashboard: 'feature.dashboard.view',
  cash: 'feature.cash.view',
  piotSetup: 'feature.cash.actions.bulk_upload',
  scales: 'feature.scales.view',
  ofdSbis: 'feature.cash.view',
  integrationJournal: 'feature.journal.integration.view',
  chzJournal: 'feature.journal.chz.view',
  certificates: 'feature.certificates.view',
  mtswifi: 'feature.mtswifi.view',
  trassir: 'feature.trassir.view',
  statistics: 'feature.dashboard.view',
  settings: 'feature.settings.view',
  settingsEdit: 'feature.settings.edit',
  accessManage: 'feature.access.manage',
  logsView: 'feature.logs.view',
  logsManage: 'feature.logs.manage',
} as const

export type PermissionKey = (typeof PERMISSIONS)[keyof typeof PERMISSIONS]

export type NavGroup = 'overview' | 'equipment' | 'services' | 'system'

export const NAV_GROUP_LABELS: Record<NavGroup, string> = {
  overview: '',
  equipment: 'Оборудование',
  services: 'Сервисы',
  system: 'Система',
}

export interface NavItem {
  key: string
  path: string
  label: string
  permission: string | null
  group: NavGroup
  /** Only visible when profile.id === 1 */
  adminOnly?: boolean
}

export const NAV_ITEMS: NavItem[] = [
  { key: 'home', path: '/', label: 'Главная', permission: PERMISSIONS.dashboard, group: 'overview' },
  { key: 'cash', path: '/cash', label: 'Кассы', permission: PERMISSIONS.cash, group: 'equipment' },
  {
    key: 'pos-incidents',
    path: '/cash/incidents',
    label: 'Инциденты',
    permission: PERMISSIONS.trassir,
    group: 'equipment',
  },
  {
    key: 'piot-setup',
    path: '/piot-setup',
    label: 'Настройка ПиОТ',
    permission: PERMISSIONS.piotSetup,
    group: 'equipment',
  },
  { key: 'scales', path: '/scales', label: 'ВСО', permission: PERMISSIONS.scales, group: 'equipment' },
  { key: 'ofd-sbis', path: '/ofd-sbis', label: 'ОФД СБИС', permission: PERMISSIONS.ofdSbis, group: 'services' },
  {
    key: 'integration-journal',
    path: '/journals/integration',
    label: 'Журнал МИ',
    permission: PERMISSIONS.integrationJournal,
    group: 'services',
  },
  {
    key: 'chz-journal',
    path: '/journals/chz',
    label: 'Журнал ЛМЧЗ',
    permission: PERMISSIONS.chzJournal,
    group: 'services',
  },
  {
    key: 'certificates',
    path: '/certificates',
    label: 'Сертификаты УТМ',
    permission: PERMISSIONS.certificates,
    group: 'services',
  },
  {
    key: 'mtswifi',
    path: '/mtswifi',
    label: 'Гостевой МТС Wi-Fi',
    permission: PERMISSIONS.mtswifi,
    group: 'services',
  },
  { key: 'trassir', path: '/trassir', label: 'TRASSIR', permission: PERMISSIONS.trassir, group: 'services' },
  {
    key: 'statistics',
    path: '/statistics',
    label: 'Дашборд',
    permission: PERMISSIONS.statistics,
    group: 'system',
  },
  {
    key: 'logs',
    path: '/logs',
    label: 'Логи',
    permission: PERMISSIONS.logsView,
    group: 'system',
  },
  { key: 'settings', path: '/settings', label: 'Настройки', permission: PERMISSIONS.settings, group: 'system' },
]

export const NAV_GROUP_ORDER: NavGroup[] = ['overview', 'equipment', 'services', 'system']

export const ROUTE_PERMISSION: Record<string, string | null> = Object.fromEntries(
  NAV_ITEMS.map((item) => [item.path, item.permission]),
)

export function resolveNavLabel(pathname: string): string {
  if (pathname === '/') return 'Главная'
  const exact = NAV_ITEMS.find((i) => i.path === pathname)
  if (exact) return exact.label
  if (pathname.startsWith('/cash/') && pathname !== '/cash/incidents') return 'Касса'
  if (pathname.startsWith('/profile')) return 'Профиль'
  if (pathname.startsWith('/weather')) return 'Погода'
  if (pathname.startsWith('/kit-kiosk')) return 'Обновление KIT Киоск'
  if (pathname.startsWith('/logs')) return 'Логи'
  const prefix = NAV_ITEMS.find((i) => i.path !== '/' && pathname.startsWith(i.path))
  return prefix?.label || 'Страница'
}
